/**
 * Clé de traduction d'affluence unifiée, utilisée partout où un statut de site/file est
 * présenté à l'utilisateur. Retourne une clé (namespace `components`), pas un libellé déjà
 * traduit : à résoudre par l'appelant via `TranslateService`/`| translate` pour respecter
 * la langue active, au lieu de figer le texte en français.
 */

export type AffluenceLevel = 'fluide' | 'moderee' | 'forte';

export const AFFLUENCE_LABEL_KEYS: Record<AffluenceLevel, string> = {
  fluide: 'components.queueCard.status.fluid',
  moderee: 'components.queueCard.status.moderate',
  forte: 'components.queueCard.status.high',
};

export function affluenceLabelKey(level: AffluenceLevel): string {
  return AFFLUENCE_LABEL_KEYS[level];
}
